import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudButtonModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import {
	ZkButtonModule,
	ZkDialogModule,
	ZkIconModule,
	ZkTooltipModule,
} from '@zenklub/ng-ui';

import { ReceiptModalComponent } from '../receipt-modal/receipt-modal.component';
import { ReceiptButtonComponent } from './receipt-button.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		// NG-UI
		ZkButtonModule,
		ZkDialogModule,
		ZkIconModule,
		ZkTooltipModule,
		FreudButtonModule,
	],
	declarations: [ReceiptButtonComponent, ReceiptModalComponent],
	exports: [ReceiptButtonComponent, ReceiptModalComponent],
	entryComponents: [ReceiptModalComponent],
})
export class ReceiptButtonModule {}
